module.exports = __webpack_public_path__ + "static/media/avon_grow_tr.bcee1eb6.svg";